export const NOT_LOGGED_DELAY = 5000;
export const THROTTLE_GAP = 200;

export const BREAKPOINT_MOBILE = 550;
export const BREAKPOINT_PHABLET = 750;
export const BREAKPOINT_TABLET = 1000;
export const BREAKPOINT_DESKTOP = 1200;

export const THUMBNAIL_SIZE = {
    height: 200,
    width: 180,
};
export const VIEWPORT_SIZE_OFFSET = 40;
